import React from 'react';
import { CommandBar } from '@fluentui/react/lib/CommandBar';
import { useTranslation } from 'react-i18next';
import { messageService } from '../../../services/messageService';

const CommandBarLeft = (props: { disable: boolean }) => {
  const { t } = useTranslation();


  const getItems = () => {
    return [
      {
        key: 'new',
        text: t('new'),
        iconProps: { iconName: 'Add' },
        onClick: () => {
          messageService.sendMessage({ isNewStock: true });
        },
        disabled: props.disable,
      },
      // {
      //     key: 'Clone',
      //     name: t('clone'),
      //     disabled: props.disable,
      //     iconProps: { iconName: 'Copy' },
      //     onClick: () => {}
      // }
    ];
  };

  return (
    <div>
      <CommandBar
        items={getItems()}
        ariaLabel="Use left and right arrow keys to navigate between commands"
      />
    </div>
  );
};

export default CommandBarLeft;
